import React, {useState, useEffect} from 'react';
import {Box, Grid, Typography, ListItem, ListItemText, Button, Skeleton} from "@mui/material";
import BackButton from '../common/back-button';
import CertificateIcon from "../../assets/icons/certificate.png";
import AnomalyLogActionDialog from './dialog/anomaly-log-action.dialog';
import useWidth from "../../hooks/useWidth";
import AnomalyHistoryLogComponent from "./anomaly-history-log.component";
import useAnomalyDetection from "../../hooks/useAnomalyDetection";
import moment from "moment";
import AnomalyLocationsComponent from './anomaly-locations.component';

const AnomalyDetailViewComponent = () => {

    const breakpoints = useWidth();

    const {isFetchingAnomalyDetails, anomalyDetectionDetails, anomalyHistoryLogList, getAnomalyDetectionDetailView, getHistoryLogList,
        isCreatingAnomalyDetectionRemarks, isRemarksSaved, isInvalidatingAnomalyDetectionRemarks, isRemarksInvalidated, 
        createAnomalyDetectionRemarks, invalidateAnomalyDetectionRemarks
    } = useAnomalyDetection();

    const [openLogAction, setOpenLogAction] = useState(false);
    const [verificationLogs, setVerificationLogs] = useState([]);

    let anomalyId = new URLSearchParams(window.location.search).get("anomalyId");

    useEffect(() => {
        getAnomalyDetectionDetailView(anomalyId);
        getHistoryLogList(anomalyId);
    }, [anomalyId])

    useEffect(() => {
        if (isRemarksSaved) {
            setOpenLogAction(false);
            getAnomalyDetectionDetailView(anomalyId); 
        }
    }, [isRemarksSaved])

    useEffect(() => {
        if (isRemarksInvalidated) {
            setOpenLogAction(false);
            getAnomalyDetectionDetailView(anomalyId);
        }
    }, [isRemarksInvalidated])

    
    useEffect(()=>{
        if(anomalyHistoryLogList == null && anomalyHistoryLogList.length == 0) return;
        var verification_logs = anomalyHistoryLogList.map(item => item.verificationLogs);
        setVerificationLogs(verification_logs);
    },[anomalyHistoryLogList]);

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6" sx={{color: "#58565f", fontWeight: 600, fontSize: 20}}>
                        Anomaly Detail View
                    </Typography>
                </Grid>
            </Grid>

            <Box sx={{mt: 3}}>
                <BackButton />
                
                <Box sx={{backgroundColor: "#fff", borderRadius: "8px", padding: 2, mt: 2}}>
                    <Grid container spacing={1}>
                        <Grid item xs={7}>
                            <Grid container>
                                <Grid item xs={3.5}>
                                    <ListItem sx={{pt: "2px", pb: "2px"}}>
                                        <ListItemText sx={{display: "flex"}}
                                            primary={
                                                <Typography sx={{color: "#58565f", fontSize: 14, fontWeight: "bold"}}>
                                                    OVI Reference: &nbsp;
                                                </Typography>
                                            } 
                                            secondary={(isFetchingAnomalyDetails) ?
                                                    <Skeleton variant="text" sx={{fontSize: 14, width: "100px", backgroundColor: "#d8d8fdbd"}} />
                                                :
                                                    <Typography sx={{color: "#58565f", fontSize: 14}}>
                                                        {anomalyDetectionDetails?.ovi}
                                                    </Typography>
                                            }
                                        />
                                    </ListItem>
                                </Grid>

                                <Grid item xs={1.5}>
                                    <img alt="authenticated-icon" src={CertificateIcon} style={{height: 28, width: 28, marginTop: "7px"}}/>
                                </Grid>

                                <Grid item xs={4.5}>
                                    <Button variant="contained" sx={{width: (breakpoints == "xs" || breakpoints == "sm") ? {} : "36%", mt: "6px", height: "33px", textTransform: "none", backgroundColor: "#5959D8", color: "#fff", "&:hover": {backgroundColor: "#5959D8", color: "#fff"}}}
                                        onClick={(e) => setOpenLogAction(true)}
                                    >
                                        Log Action
                                    </Button>
                                </Grid>
                            </Grid>

                            <ListItem sx={{pt: "4px", pb: "6px"}}>
                                <ListItemText sx={{display: "flex"}}
                                    primary={
                                        <Typography sx={{color: "#58565f", fontSize: 14, fontWeight: "bold"}}>
                                            Name: &nbsp;
                                        </Typography>
                                    } 
                                    secondary={(isFetchingAnomalyDetails) ?
                                        <Skeleton variant="text" sx={{fontSize: 14, width: "200px", backgroundColor: "#d8d8fdbd"}} />
                                    :
                                        <Typography sx={{color: "#58565f", fontSize: 14}}>
                                            {anomalyDetectionDetails?.authenticationLogs?.name}
                                        </Typography>
                                    }
                                />
                            </ListItem>

                            <ListItem sx={{pt: "4px", pb: "6px"}}>
                                <ListItemText sx={{display: "flex"}}
                                    primary={
                                        <Typography sx={{color: "#58565f", fontSize: 14, fontWeight: "bold"}}>
                                            Used For: &nbsp;
                                        </Typography>
                                    } 
                                    secondary={(isFetchingAnomalyDetails) ?
                                        <Skeleton variant="text" sx={{fontSize: 14, width: "200px", backgroundColor: "#d8d8fdbd"}} />
                                    :
                                        <Typography sx={{color: "#58565f", fontSize: 14}}>
                                            {anomalyDetectionDetails?.authenticationLogs?.used_for}
                                        </Typography>
                                    }
                                />
                            </ListItem>

                            <ListItem sx={{pt: "4px", pb: "6px"}}>
                                <ListItemText sx={{ display: "flex"}}
                                    primary={
                                        <Typography sx={{ color: "#58565f", fontSize: 14, fontWeight: "bold" }}>
                                            Description: &nbsp;
                                        </Typography>
                                    }
                                    secondary={(isFetchingAnomalyDetails) ?
                                        <Skeleton variant="text" sx={{fontSize: 14, width: "200px", backgroundColor: "#d8d8fdbd"}} />
                                    :
                                        <Typography sx={{color: "#58565f", fontSize: 14}}>
                                            {anomalyDetectionDetails?.product?.description}
                                        </Typography>
                                    }
                                />
                            </ListItem>

                            <ListItem sx={{pt: "4px", pb: "6px"}}>
                                <ListItemText sx={{display: "flex"}}
                                    primary={
                                        <Typography sx={{color: "#58565f", fontSize: 14, fontWeight: "bold"}}>
                                            Product Type: &nbsp;
                                        </Typography>
                                    } 
                                    secondary={(isFetchingAnomalyDetails) ?
                                        <Skeleton variant="text" sx={{fontSize: 14, width: "200px", backgroundColor: "#d8d8fdbd"}} />
                                    :
                                        <Typography sx={{color: "#58565f", fontSize: 14}}>
                                            {(anomalyDetectionDetails?.authenticationLogs?.type === "RL") ? 
                                                "Retail Level" 
                                            : 
                                                (anomalyDetectionDetails?.authenticationLogs?.type === "BL") ? 
                                                    "Box Level" 
                                            :   
                                                "Pallet Level"
                                            }
                                        </Typography>
                                    }
                                />
                            </ListItem>

                            <ListItem sx={{pt: "4px", pb: "6px"}}>
                                <ListItemText sx={{display: "flex"}}
                                    primary={
                                        <Typography sx={{color: "#58565f", fontSize: 14, fontWeight: "bold"}}>
                                            Manufactured Date: &nbsp;
                                        </Typography>
                                    } 
                                    secondary={(isFetchingAnomalyDetails) ?
                                        <Skeleton variant="text" sx={{fontSize: 14, width: "200px", backgroundColor: "#d8d8fdbd"}} />
                                    :
                                        <Typography sx={{color: "#58565f", fontSize: 14}}>
                                            {moment(anomalyDetectionDetails?.authenticationLogs?.manufactured_date).format("MM/DD/YYYY")}
                                        </Typography>
                                    }
                                />
                            </ListItem>

                            <ListItem sx={{pt: "4px", pb: "6px"}}>
                                <ListItemText sx={{display: "flex"}}
                                    primary={
                                        <Typography sx={{color: "#58565f", fontSize: 14, fontWeight: "bold"}}>
                                            Expiration Date: &nbsp;
                                        </Typography>
                                    } 
                                    secondary={(isFetchingAnomalyDetails) ?
                                        <Skeleton variant="text" sx={{fontSize: 14, width: "200px", backgroundColor: "#d8d8fdbd"}} />
                                    :
                                        <Typography sx={{color: "#58565f", fontSize: 14}}>
                                            {moment(anomalyDetectionDetails?.authenticationLogs?.expiration_date).format("MM/DD/YYYY")}
                                        </Typography>
                                    }
                                />
                            </ListItem>

                            <ListItem sx={{pt: "4px", pb: "6px"}}>
                                <ListItemText sx={{display: "flex"}}
                                    primary={
                                        <Typography sx={{color: "#58565f", fontSize: 14, fontWeight: "bold"}}>
                                            Fraud Type: &nbsp;
                                        </Typography>
                                    } 
                                    secondary={(isFetchingAnomalyDetails) ?
                                        <Skeleton variant="text" sx={{fontSize: 14, width: "200px", backgroundColor: "#d8d8fdbd"}} />
                                    :
                                        <Typography sx={{color: "#58565f", fontSize: 14}}>
                                            {anomalyDetectionDetails?.fraud_type}
                                        </Typography>
                                    }
                                />
                            </ListItem>

                            <ListItem sx={{pt: "4px", pb: "6px"}}>
                                <ListItemText sx={{display: "flex"}}
                                    primary={
                                        <Typography sx={{color: "#58565f", fontSize: 14, fontWeight: "bold"}}>
                                            Remarks: &nbsp;
                                        </Typography>
                                    } 
                                    secondary={(isFetchingAnomalyDetails) ?
                                        <Skeleton variant="text" sx={{fontSize: 14, width: "200px", backgroundColor: "#d8d8fdbd"}} />
                                    :
                                        <Typography sx={{color: "#58565f", fontSize: 14}}>
                                            {(anomalyDetectionDetails?.remarks) ? anomalyDetectionDetails?.remarks : "N / A "}
                                        </Typography>
                                    }
                                />
                            </ListItem>

                            <Box sx={{margin: "16px 40px 24px 15px"}}>
                                <AnomalyHistoryLogComponent breakpoints={breakpoints} anomalyHistoryLogList={anomalyHistoryLogList} />
                            </Box>
                        </Grid>

                        <Grid item xs={5} sx={{color: "#58565f"}}>
                            { anomalyHistoryLogList.length != 0 &&  
                                <AnomalyLocationsComponent breakpoints={breakpoints} verificationLogs={verificationLogs} selectedAnomaly={null}/> 
                            }  
                        </Grid>
                    </Grid>
                </Box>
            </Box>


            {openLogAction &&
                <AnomalyLogActionDialog openLogAction={openLogAction}
                    setOpenLogAction={setOpenLogAction} breakpoints={breakpoints}
                    anomalyId={anomalyId} anomalyDetectionDetails={anomalyDetectionDetails}
                    isCreatingAnomalyDetectionRemarks={isCreatingAnomalyDetectionRemarks}
                    isRemarksSaved={isRemarksSaved}
                    isInvalidatingAnomalyDetectionRemarks={isInvalidatingAnomalyDetectionRemarks}
                    isRemarksInvalidated={isRemarksInvalidated}
                    createAnomalyDetectionRemarks={createAnomalyDetectionRemarks}
                    invalidateAnomalyDetectionRemarks={invalidateAnomalyDetectionRemarks}
                />
            }
        </Box>
    )
}

export default AnomalyDetailViewComponent